import { Container, RadioGroup, Typography } from '@prenuvo/halo-web';
import { useState } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { paymentOptions } from '@/constants/paymentMethod';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';

import AffirmLogo from './AffirmLogo';
import { StripeElements } from './StripeElements';
import { ISAUSTRALIANLOCATION } from '@/constants';

export const PaymentMethod = () => {
  const { add, locationId,paymentMethodType } = usePrenuvoStore(
    useShallow((state) => ({
      add: state.payment.methods.add,
      locationId: state.scan.locationId,
      paymentMethodType: state.payment.paymentMethodType,
    })),
  );

  const [paymentMethod, setPaymentMethod] = useState<string>(paymentMethodType);

  const handleValueChange = (option: string) => {
    setPaymentMethod(option);
    add({ paymentMethodType: option });
  };
  
  const isAustralianLocation = ISAUSTRALIANLOCATION(locationId);
  const filteredPaymentOptions = isAustralianLocation 
    ? paymentOptions.filter((option) => option.value !== 'affirm')
    : paymentOptions;

  return (
    <div className="mb-8 flex flex-col gap-6 pt-6">
      <Typography variant="h4" as="h4">
        Payment Information
      </Typography>
      <Container>
        {!isAustralianLocation ? (
        <>
          <RadioGroup
            value={paymentMethodType}
            onValueChange={handleValueChange}
            options={paymentOptions}
          />
          <a
            href="https://www.affirm.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 flex items-center gap-2"
          >
            <AffirmLogo />
            <Typography variant="link" as="p">
              Learn more about Affirm
            </Typography>
          </a>
        </>
        ) : (
        <RadioGroup
          value={paymentMethodType}
          onValueChange={handleValueChange}
          options={filteredPaymentOptions}
        />
        )}
      </Container>
      {paymentMethod === 'stripe' ? <StripeElements /> : null}
    </div>
  );
};
